import { FormikProps } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { TableColumn } from 'react-data-table-component';
import { Col, Input } from 'reactstrap';

import { NomenclaturesFromEntityListData } from '../../../models/nomenclatures-from-entity-list-data';

interface MakeColumnsProps {
  validation: FormikProps<any>;
  disabled: boolean;
}

interface NomenclatureTextInputProps {
  id: string;
  name: string;
  value: string;
  placeholder: string;
  disabled: boolean;
  onBlur: FormikProps<any>['handleBlur'];
  onChange: FormikProps<any>['handleChange'];
}

const NomenclatureTextInput = ({
  id,
  name,
  value,
  placeholder,
  disabled,
  onBlur,
  onChange,
}: NomenclatureTextInputProps) => {
  const [localValue, setLocalValue] = useState(value || '');
  const isComposingRef = useRef(false);

  useEffect(() => {
    if (!isComposingRef.current) {
      setLocalValue(value || '');
    }
  }, [value]);

  return (
    <Input
      type="text"
      id={id}
      name={name}
      value={localValue}
      onCompositionStart={() => {
        isComposingRef.current = true;
      }}
      onCompositionEnd={(e) => {
        isComposingRef.current = false;
        setLocalValue(e.currentTarget.value);
        onChange(e);
      }}
      onChange={(e) => {
        setLocalValue(e.target.value);
        if (!isComposingRef.current) {
          onChange(e);
        }
      }}
      onBlur={(e) => {
        isComposingRef.current = false;
        onBlur(e);
      }}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

export const makeNomenclaturesFromEntityListColumns = ({
  validation,
  disabled,
}: MakeColumnsProps): TableColumn<
  NomenclaturesFromEntityListData[number]
>[] => {
  return [
    {
      name: 'Nomenclatura',
      width: '30%',
      sortable: true,
      selector: (row) => row.name,
    },
    {
      name: 'Singular',
      selector: (row) => row.singularInput.value,
      cell: (row) => (
        <Col>
          <NomenclatureTextInput
            id={`${row.key}.singular`}
            name={`${row.key}.singular`}
            value={validation?.values?.[row.key].singular}
            onBlur={validation?.handleBlur}
            onChange={validation?.handleChange}
            placeholder={row.singularInput.placeholder}
            disabled={disabled}
          />
        </Col>
      ),
    },
    {
      name: 'Plural',
      selector: (row) => row.pluralInput.value,
      cell: (row) => (
        <Col>
          <NomenclatureTextInput
            id={`${row.key}.plural`}
            name={`${row.key}.plural`}
            value={validation?.values?.[row.key].plural}
            onBlur={validation?.handleBlur}
            onChange={validation?.handleChange}
            placeholder={row.pluralInput.placeholder}
            disabled={disabled}
          />
        </Col>
      ),
    },
  ];
};
